<template>
  <div :class="['bar',{'bar__trangle':type==='trangle'},{'bar__dot':type==='dot'},{'bar__line':type==='line'}]" :style="barStyle">
    <div v-if="!$slots.default" class="active-shape"></div>
    <div v-else class="slot-class">
      <!-- <svg-icon name="xiala"></svg-icon> -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
// import SvgIcon from '@/components/public/SvgIcon.vue'
export default {
  props: {
    actIndex: {},
    // SvgIcon: {},
    activeTabClass: {
      default: '.activeTab'
    },
    type: {
      default: 'trangle'
    }

  },
  data() {
    return {
      barStyle: {},
      actEl: null,
    };
  },

  // computed:{
  //    barStyle(){
  //     //   debugger
  //     //    await this.$nextTick(()=>{
  //           this.actEl =  document.querySelector('.activeTab')
  //         // })
  //   console.log("🚀 ~  this.actEl",  this.actEl)
  // //   this.actIndex
  //   console.log("🚀 ~ this.actIndex", this.actIndex)

  //   debugger

  //         return {
  //             width:`${this.actEl&&this.actEl.clientWidth}px`,
  //             transform: `translateX(${this.actEl&&this.actEl.offsetLeft}px)`
  //         }

  //     }
  // },
  //   watch: {
  //     actIndex: {
  //       handler() {
  //         this.actEl = document.querySelector(".activeTab");
  //         if (!this.actEl) handler();
  //         this.barStyle = {
  //           width: `${this.actEl && this.actEl.clientWidth}px`,
  //           transform: `translateX(${this.actEl && this.actEl.offsetLeft}px)`,
  //         };
  //       },
  //       immediate: true,
  //     },
  //   },
  mounted() {
    //console.log("🚀 ~ this", this)
    // this
    this.actEl = document.querySelector(this.activeTabClass);
    this.$watch(
      "actIndex",
      function () {
        this.actEl = document.querySelector(this.activeTabClass);
        this.barStyle = {
          width: `${this.actEl && this.actEl.clientWidth}px`,
          transform: `translateX(${this.actEl && this.actEl.offsetLeft}px)`,
          '-ms-transform': `translateX(${this.actEl && this.actEl.offsetLeft}px)`
        };
        //console.log(this.barStyle, "this.barStyle")
      },
      { immediate: true }
    );
    // debugger
    //   this.actEl =  document.querySelector('.activeTab')
    // this.$parent.$refs['tab']
    // console.log("🚀 ~ this.$parent.$refs['tab']",this.actEl )
  },
};
</script>

<style lang="scss" scoped>
// 主字体颜色
$font-lord: #333333;
// 次字体颜色
$font-bout: #777777;
// N次字体颜色
$font-minbout: #aaa;
// 描边颜色
$stroke-color-index1: #e0e0e0;
$stroke-color-index2: #f0f0f0;
// 按钮描边
$btn-colorBR: #dddddd;
// 选中动态颜色
$atv-colorBR: #0046b9;
// 字体大小
$font-24: 24px;
$font-18: 18px;
$font-16: 16px;
$font-14: 14px;
$font-13: 13px;

.slot-class {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  line-height: initial;
}
.bar {
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 0.3s ease-in-out;
}
.bar.bar__dot {
  // position: relative;
  &::after {
    content: "";
    width: 6px;
    height: 6px;
    // background: #ffffff;
    background: $atv-colorBR;

    border-radius: 50%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
.bar.bar__line {
  // position: relative;
  &::after {
    content: "";
    width: 100%;
    height: 1px;
    background: $atv-colorBR;

    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.bar.bar__trangle {
  .active-shape {
    position: absolute;

    content: "";
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 13px solid $atv-colorBR;
    bottom: 0;

    left: 50%;
    transform: translateX(-50%);
    //   -ms-transform: translateX(-50%);
  }
}
</style>